// extracted by mini-css-extract-plugin
export default {"cardContainer":"newsCard_cardContainer__yHqFA","cardImg":"newsCard_cardImg__dGGEM","cardWrapperImg":"newsCard_cardWrapperImg__ik+jo","cardHeadline":"newsCard_cardHeadline__+FAZg"};